<template>
  <div class="main-layout predicted-item-page">
    <el-card class="box-inner box-bg">
      <c-title slot="header" title="是否住校"></c-title>
      <div class="pb110">
        <div class="div-scroll">
          <div class="form-container">
            <el-form
              :model="form"
              ref="ruleForm"
              label-width="80px"
              label-position="left"
            >
              <el-form-item label="是否住校">
                <el-switch
                  v-model="isOrNot"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>
              <div class="tips-container">
                <div class="tips">
                  <div class="title">
                    <i class="el-icon-info"></i><span>温馨提示</span>
                  </div>
                  <p>
                    若您选择住校，本次选择将作为分配宿舍的依据，待您的宿舍与床位分配完成后，您可在“我的宿舍”中查看详情。
                  </p>
                  <p>若您选择不住校，则按照下方要求提交相关资料：</p>
                  <p>
                    1.家住"鄂城区"，且所住房屋所有人是申请人或其直系亲属，请提交房产证或房屋租赁合同复印件，以供校方审核；
                  </p>
                  <p>
                    2.因身患疾病等原因不适合集体住宿但又未达到休学条件，请提交医院证明和房屋租赁合同复印件，且需家长陪读；
                  </p>
                  <p>3.其它特殊原因。</p>
                  <p>
                    申请办理走读的相关材料（以下材料请拍照上传，材料纸质版请于到校后根据学院安排提交）：
                  </p>
                  <p>
                    (1)《鄂州职业大学学生走读申请表》；<br />
                    (2)《鄂州职业大学走读学生家长承诺书》；<br />
                    (3)直系亲属（父亲或母亲）身份证复印件；<br />
                    (4)户口本家庭成员页复印件；<br />
                    (5)房产证或房屋租赁合同复印件。
                  </p>
                </div>
              </div>
              <div class="template-download" v-show="isOrNot == 0">
                <a :href="link">点击下载申请表、承诺书模板</a>
              </div>
              <div class="img-upload" v-if="isOrNot == 0">
                <div class="evidence-upload upload-item">
                  <div class="title">
                    <span class="red">*</span>上传申请表及相关资料
                  </div>
                  <el-upload
                    action="/account/sys/static/upload"
                    list-type="picture-card"
                    accept="image/jpeg,image/jpg,image/png,image/bmp,image/gif"
                    :file-list="fileList"
                    :headers="{ token }"
                    :on-success="handlePictureSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handlePictureRemove"
                    :on-error="handleError"
                  >
                    <i class="el-icon-plus" slot="default"></i>
                  </el-upload>
                </div>
              </div>
              <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { guid } from "@/libs/tools.js";
import mUpload from "@/mixins/MUpload.js";
export default {
  mixins: [mUpload],
  data() {
    return {
      SUCCESS_CODE: "",
      isOrNot: true,
      studentId: "",
      forecastLinkId: "",
      isSubmit: false,
      link: "http://yx.ezu.cn/static/welcome/学生走读相关材料.doc",
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      handleData: {},
      pictureUrl: [],
      form: {},
    };
  },
  created() {
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.token = localStorage.getItem("token");
    this.studentId = JSON.parse(localStorage.getItem("userInfo")).studentId;
    this.forecastLinkId = this.$route.params.id;
    this.isOrNot =
      this.$route.params.isOrNot == "null"
        ? 1
        : Number(this.$route.params.isOrNot);
    this.status = this.$route.params.status;
    // 初始化handleData
    this.handleData = {
      studentId: this.studentId,
      forecastLinkId: this.forecastLinkId,
      isOrNot: this.isOrNot,
      pictureUrl: [],
    };
    // 获取详情
    this.handleGet();
  },
  mounted() {
    if (this.status == 0) {
      this.$confirm("请确认是否住校", "请确认", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        showClose: false,
        type: "warning",
        center: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(() => {
          console.log("是");
          this.isOrNot = 1;
          this.handleConfirm();
        })
        .catch(() => {
          console.log("否");
          this.isOrNot = 0;
          this.$message.warning("请按要求提交相关资料！");
        });
    }
  },
  methods: {
    submit() {
      // 当选择不参加城镇医保时，校验是否上传了承诺书
      if (this.isOrNot == 0 && this.fileList.length == 0) {
        return this.$message.error("上传申请表及相关资料！");
      }
      this.$confirm("请确认无误后提交，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleConfirm();
        })
        .catch(() => {});
    },
    // 确认提交
    handleConfirm() {
      this.handleData.isOrNot = this.isOrNot;
      if (this.isOrNot == 1) {
        this.handleData.pictureUrl = [];
      } else {
        let pictureUrl = this.fileList.map((item) => item.url);
        this.handleData.pictureUrl = pictureUrl;
      }
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleSave();
      }
    },
    // 获取住宿详情
    handleGet() {
      this.$http
        .get(
          `/welcome-forecast/student/forecast/${this.forecastLinkId}/${this.studentId}`
        )
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            if (res.data) {
              this.handleData = res.data;
              // 回显图片
              if (res.data.pictureUrl && res.data.pictureUrl.length) {
                res.data.pictureUrl.forEach((item) =>
                  this.fileList.push({ url: item, name: item })
                );
                this.pictureUrl = [...this.fileList];
              }
            }
          }
        })
        .catch((err) => {});
    },
    // 新增数据
    handleSave() {
      this.isSubmit = true;
      let params = Object.assign({}, this.handleData);
      this.$http
        .post("/welcome-forecast/student/forecast/saveInsurance", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error(res.msg);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error("操作失败" + err);
          this.isSubmit = false;
        });
    },
    // 更新数据
    handleUpdate() {
      this.isSubmit = true;
      let params = Object.assign({}, this.handleData);
      this.$http
        .post("/welcome-forecast/student/forecast/updateInsurance", params)
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.$message.success(res.msg);
            // this.$router.go(-1);
            this.$router.replace("/welcome/student/predicted");
          } else {
            this.$message.error(res.msg);
          }
          this.isSubmit = false;
        })
        .catch((err) => {
          this.$message.error("操作失败" + err);
          this.isSubmit = false;
        });
    },
    handlePictureSuccess(res, file, fileList) {
      if (res.code == this.SUCCESS_CODE) {
        file.url = res.data.url;
        this.fileList = fileList;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleFormRemove(file, fileList) {
      this.formFileList = fileList;
    },
    handlePictureRemove(file, fileList) {
      this.fileList = fileList;
      let index = this.pictureUrl.findIndex((item) => item.name == file.name);
      this.pictureUrl.splice(index, 1);
    },
    handleError(err) {
      this.$message.error("上传失败，" + err);
    },
    // 自定义上传方法
    customUpload(e) {
      console.log(e);
      let self = this;
      var file = e.file;
      var fileName = guid();
      self.obsUpload(file, fileName, this.afterObsUpload);
    },
    afterObsUpload(obsUrl, file) {
      this.pictureUrl.push({ url: obsUrl, name: file.name });
    },
    // obsUpload(file, key, callback) {
    //   let self = this;
    //   this.isLoading = true;
    //   var ak = self.$OBS_AK;
    //   var sk = self.$OBS_SK;
    //   var server = self.$OBS_SERVER;
    //   var bucket = self.$OBS_BUCKET;
    //   let prefix = self.$OBS_PREFIX;
    //   var obsClient = new ObsClient({
    //     access_key_id: ak,
    //     secret_access_key: sk,
    //     server: server,
    //     timeout: 60 * 5,
    //   });
    //   // put objects
    //   obsClient
    //     .putObject({
    //       Bucket: bucket,
    //       Key: key,
    //       Metadata: { property: "property-value" },
    //       SourceFile: file,
    //     })
    //     .then(function (result) {
    //       if (result.CommonMsg.Status == 200) {
    //         console.log(result);
    //         // 上传成功后的操作
    //         callback && callback(file, key);
    //         let obsUrl = prefix + key;
    //         self.pictureUrl.push({ url: obsUrl, name: file.name });
    //         // console.log(self.pictureUrl);
    //       }
    //       self.isLoading = false;
    //     })
    //     .catch(function (err) {
    //       self.isLoading = false;
    //       this.$message.error(err);
    //     });
    // },
  },
};
</script>
